import React from 'react';

import UserProfile from 'components/app/directory/user-details/UserProfile';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Tabs, Tab } from 'react-bootstrap';
import DirectoryService from 'components/app/directory/DirectoryService';
import FormModal from '../../common/FormModal';
import WODProfileBanner from './WODProfileBanner';
import { useState, useEffect } from 'react';
import PersonalForm from './PersonalForm';
import TrainingHistoryList from '../history/TrainingHistoryList';
import PasswordSettingsForm from 'components/app/directory/user-details/PasswordSettings';

const WODMyDetails = () => {
  const { identifier } = useParams();
  const [profile, setProfile] = useState();
  const [showError, setShowError] = useState(false);
  const [showTabs, setShowTabs] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [key, setKey] = useState('personal');
  useEffect(() => {
    let athleteIdentifer = identifier;
    const loggedProfile = DirectoryService.retrieveLoggedProfile();
    if (identifier === undefined) {
      athleteIdentifer = loggedProfile.identifier;
    }
    if (athleteIdentifer !== undefined) {
      DirectoryService.retrieveProfile(athleteIdentifer)
        .then(profile => {
          setProfile(profile);
          if (DirectoryService.isLoggedByWODAdmin() ||
            athleteIdentifer === loggedProfile.identifier) {
            setShowTabs(true);
          }
        })
        .catch(() => {
          setShowError(false);
        });
    } else {
      setShowTabs(true);
    }
  }, []);
  return (
    <>
      {modalShow && (
        <FormModal
          message={'Your details has been updated!'}
          modalShow={modalShow}
          setModalShow={setModalShow}
        />
      )}
      <>
        {profile && <WODProfileBanner profile={profile} />}
        {showTabs && (
          <Tabs defaultActiveKey={key} id="controlled-tab-example">
            <Tab
              eventKey="personal"
              title="Personal"
              className="border-bottom border-x p-3"
            >
              {profile && <PersonalForm profile={profile} />}
            </Tab>
            <Tab
              eventKey="training-history"
              title="Training History"
              className="border-bottom border-x p-3"
            >
              {profile && <TrainingHistoryList profile={profile} showHeader={false} />}
            </Tab>
            <Tab
              eventKey="settings-history"
              title="Settings"
              className="border-bottom border-x p-3">
              <PasswordSettingsForm profile={profile} showHeader={false}/>
            </Tab>
          </Tabs>
        )}
      </>
    </>
  );
};

WODMyDetails.propTypes = {
  params: PropTypes.shape({
    identifier: PropTypes.string
  })
};

export default WODMyDetails;
